<div class="big-chip"  [ngStyle]="{ 'background-color': selected? color : altColor }">
  <span class="title-text" [ngStyle]="{ 'color': selected? '#FFFFFF' : '#0D0D0D' }">{{label}}</span>
  <span class="mini-chip">
    <span class="inner-text">
       {{miniLabel}}
    </span>
   </span>

</div>
